// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"473":"29deb0ea10a2dff2","888":"c0f4197ddb7205ba"}[chunkId] + ".css";
};